<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th @click="handleSort('label')" class="sortable-header">
          {{$t('name_journeys')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('label')"
          >
        </th>
        <th @click="handleSort('type')" class="sortable-header">
          {{$t('types')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('type')"
          >
        </th>
        <th @click="handleSort('status')" class="sortable-header">
          {{$t('status')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('status')"
          >
        </th>
        <th @click="handleSort('sendDate')" class="sortable-header">
          {{$t('send_date')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('sendDate')"
          >
        </th>
      </tr>
      </thead>

      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="(item, index) in data" :key="index">
        <td class="td-style">
          <router-link class="table-row name-padding" :to="'/notification/' + item.notificationId">
            <img v-if="item?.content?.type === 'video'" src="../../../assets/images/videoOutline.svg" />
            <img v-else-if="item?.content?.type === 'blog'"  src="../../../assets/images/blogOutline.svg" />
            <img v-else-if="item?.content?.type === 'text'" src="../../../assets/images/documentOutline.svg" />
            <img v-else-if="item?.content?.type === 'documentDownload'" src="../../../assets/images/downloadOutline.svg" />
            <img v-else-if="item?.content?.type === 'documentUpload'" src="../../../assets/images/uploadOutline.svg" />
            <img v-else-if="item?.content?.type === 'link'" src="../../../assets/images/linkOutline.svg" />
            <img v-else-if="item?.content?.type === 'audio'" src="../../../assets/images/audioOutline.svg" />
            <img v-else-if="item?.content?.type === 'interview'" src="../../../assets/images/camOutline.svg" />
            <img v-else-if="item?.content?.type === 'offer'" src="../../../assets/images/notificationOutline.svg" />

            <div class="td-col">
              <span class="notif-title" v-if="item?.content?.label">{{item?.content?.label}}</span>
              <i class="notif-title" v-else>
                {{$t('no_label')}}
              </i>
              <span class="notif-subject">{{ item?.content?.subject }}</span>
            </div>
          </router-link>
        </td>

        <td class="td-style td-row">
          <div class="table-row">
            <span class="type-tag" v-for="type in item.types">{{type}}</span>
          </div>
        </td>

        <td>
          <div class="status-tag" :class="item.status ? 'Active' : 'Draft'">
            <div class="status-dot" :class="item.status ? 'Active' : 'Draft'"></div>
            <span>{{item.status ? this.$t('active') : this.$t('draft')}}</span>
          </div>
        </td>

        <td class="td-style">
          <span class="test-class" v-if="item.sendDate">
            {{item.sendDate}}
          </span>
          <i class="test-class" v-else>
            {{$t('no_send_date')}}
          </i>
        </td>
      </tr>

      <tr v-else>
        <td colspan="4" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>
      <tr v-if="!loading && data.length === 0 ">
        <td colspan="4" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import FilterModal from '@/components/tables/Company/CompanyFilterModal.vue';
import CompanyFieldFilter from '@/components/table-filters/CompanyFieldFilter.vue';
import ProgramFilter from "@/components/table-filters/NumberFilter.vue";
import UserAmountFilter from "@/components/table-filters/MinMaxNumberFilter.vue";
import PaymentVolume from "@/components/table-filters/PaymentVolume.vue";
import DateFilter from "@/components/table-filters/DateFilter.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {VueSpinner} from "vue3-spinners";
import {truncate, stripHtmlTags} from "@/utils/utils";

export default {
  components: {
    DateFilter,
    PaymentVolume,
    UserAmountFilter,
    AddUserModal,
    FilterModal,
    CompanyFieldFilter,
    ProgramFilter,
    ExpandableSearch,
    VueSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      required: true
    },
    rightAction: {
      type: Boolean,
      default: true
    },
    currentSort: {
      type: Object,
      default: () => ({ column: null, direction: null })
    },
    onSort: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      selectAll: false,
      showFilter: false,
      searchText: '',
    }
  },

  methods: {
    handleSort(column) {
      let newDirection = 'asc';

      // Eğer aynı kolona tıklanıyorsa direction'ı değiştir
      if (this.currentSort.column === column) {
        if (this.currentSort.direction === 'asc') {
          newDirection = 'desc';
        } else if (this.currentSort.direction === 'desc') {
          // desc'den sonra sıralamayı kaldır
          this.onSort(null, null);
          return;
        }
      }

      this.onSort(column, newDirection);
    },

    getSortClass(column) {
      if (this.currentSort.column !== column) {
        return 'sort-default';
      }

      if (this.currentSort.direction === 'asc') {
        return 'sort-asc';
      } else if (this.currentSort.direction === 'desc') {
        return 'sort-desc';
      }

      return 'sort-default';
    },

    stripHtmlTags,
    truncate,
    handleSearch(event) {
      this.searchText = event.target.value;
    }
  },

}
</script>

<style>
.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #f5f5f5;
}

.sort-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: inline-block;
  opacity: 0.4;
}

.sortable-header:hover .sort-icon {
  opacity: 0.6;
}

.sort-icon.sort-asc,
.sort-icon.sort-desc {
  opacity: 1;
}

.sort-icon.sort-asc {
  transform: rotate(0deg);
}

.sort-icon.sort-desc {
  transform: rotate(180deg);
}

.sort-icon.sort-default {
  transform: rotate(0deg);
  opacity: 0.4;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span {
  color: #4A68F8;
}

.notif-title {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #000000;
}

.notif-subject {
  font-family: euclid_regular, sans-serif;
  font-size: 10px;
  color: #344054;
}

.status-tag {
  font-family: euclid_regular, sans-serif;
  font-size: 10px;
  color: #040c2d;
  border-radius: 8px;
  padding: 3px 15px;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
}

.status-dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-tag.Draft {
  background-color: #fad9c6;
}

.status-tag.Active {
  background-color: #ddfbde;
}

.status-dot.Draft {
  background-color: #f09460;
}

.status-dot.Active {
  background-color: #3da33e;
}

.type-tag {
  font-family: euclid_regular, sans-serif;
  font-size: 10px;
  color: #040c2d;
  border-radius: 8px;
  padding: 3px 15px;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  background-color: #f2f2f2;
  text-transform: capitalize;
}

.no-data-text {
  font-style: italic;
  color: #B6C1DB;
}

.table-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.table-row.name-padding {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
